export const ABTEST_ADDITIONAL_DATA_AFTER_REG =
  'abtest_le_additional_data_after_reg';

export const ABTEST_ADDITIONAL_DATA_AFTER_REG_A =
  'abtest_le_additional_data_after_reg:a';
export const ABTEST_ADDITIONAL_DATA_AFTER_REG_B =
  'abtest_le_additional_data_after_reg:b';
